import { NavLink } from 'react-router-dom';
import asceraLogo from '../assets/ascera-logo.svg';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <NavLink to="/">
          <img src={asceraLogo} alt="ASCERA" />
        </NavLink>
      </div>
      <ul className="navbar-links">
        <li>
          <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>
            Questionnaire
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin" className={({ isActive }) => isActive ? 'active' : ''}>
            Admin
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
